export interface IValidationNotificator {
    addValidationError(element: HTMLElement, txt: string): void
    hideValidationError(element: HTMLElement): void
}


export class DefaultValidationNotificator implements IValidationNotificator
{

    private inputErrorClass: string;
    private spanErrorClass: string;

    constructor(settings: object = null)
    {
        if (this.isElementObject(settings))
        {
            if (settings["inputErrorClass"] != null)
            {
                this.inputErrorClass = settings["inputErrorClass"];
            }
            if (settings["spanErrorClass"] != null)
            {
                this.spanErrorClass = settings["spanErrorClass"];
            }
        }

        if (this.spanErrorClass == null)
        {
            this.spanErrorClass = "field-validation-error";
        }

        if (this.inputErrorClass == null)
        {
            this.inputErrorClass = "input-validation-error";
        }
        //TODO: add object settings to define classes field-validation-error
    }

    addValidationError(element: HTMLElement, txt: string): void
    {
        if (this.isElementObject(element))
        {
            if (!element.classList.contains(this.inputErrorClass))
            {
                element.classList.add(this.inputErrorClass);
            }

            if (this.isElementObject(element.nextElementSibling))
            {
                var sibling = element.nextElementSibling;
                if (sibling.nodeName == "SPAN" && sibling.classList.contains(this.spanErrorClass))
                {
                    if (txt !== "undefined" && txt != null && txt != "")
                    {
                        sibling.innerHTML = txt;
                    }
                    this.setDisplayShow(<HTMLElement>sibling);
                }
            }
        }
    }

    hideValidationError(element: HTMLElement)
    {
        if (this.isElementObject(element) && element.classList.contains(this.inputErrorClass))
        {
            element.classList.remove(this.inputErrorClass);
            if (this.isElementObject(element.nextElementSibling))
            {
                var sibling = element.nextElementSibling;
                if (sibling.nodeName == "SPAN" && sibling.classList.contains(this.spanErrorClass))
                {
                    this.setDisplayNone(<HTMLElement>sibling);
                }
            }
            this.trytoRemoveErrorClassFromParent(element, 0);
        }
    }

    private trytoRemoveErrorClassFromParent(el: HTMLElement, recursion: number)
    {
        if (this.isElementObject(el.parentElement)) {
            var parent = el.parentElement;
            if (parent.classList.contains("controls") && recursion == 0)
            {
                this.trytoRemoveErrorClassFromParent(parent, 1);
            }
            if (parent.classList.contains("has-error")) {
                parent.classList.remove("has-error");
            }
        }
    }

    private setDisplayShow(element: HTMLElement)
    {
        element.style.display = "";
    }

    private setDisplayNone(element: HTMLElement)
    {
        element.style.display = "none";
    }


    isElementObject(element)
    {
        return typeof element !== "undefined" && element != null && typeof element == "object";
    }
}